"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const react_hook_form_1 = require("react-hook-form");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const provider_test_id_1 = require("@framework/provider-test-id");
const SearchInput = props => {
    const { name = "search", inputProps, iconButtonProps = {}, paperProps = {}, ...rest } = props;
    const { testId } = (0, provider_test_id_1.useTestId)();
    const testIdProps = testId ? { "data-testid": `${testId}-${name}` } : {};
    const form = (0, react_hook_form_1.useFormContext)();
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const localizedPlaceholder = formatMessage({ id: `form.placeholders.${name}` });
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: name, control: form.control, render: ({ field }) => ((0, jsx_runtime_1.jsxs)(material_1.Paper, { sx: {
                display: "flex",
                alignItems: "center",
                my: 1,
            }, ...paperProps, children: [(0, jsx_runtime_1.jsx)(material_1.IconButton, { "aria-label": "search", sx: { p: "10px" }, ...iconButtonProps, children: (0, jsx_runtime_1.jsx)(icons_material_1.SearchOutlined, {}) }), (0, jsx_runtime_1.jsx)(material_1.InputBase, { sx: {
                        ml: 1,
                        flex: 1,
                    }, placeholder: localizedPlaceholder, inputProps: {
                        ...inputProps,
                        ...testIdProps,
                    }, ...field, ...rest })] })) }));
};
exports.SearchInput = SearchInput;
//# sourceMappingURL=index.js.map